import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';

import {
  EntityCustomIdDetailsFragment, UpdateEntityCustomIdGQL, UpdateEntityCustomIdInput
} from 'generated/graphql';

import { ToastrService } from 'core/toastr.service';
import { isNilOrEmpty } from 'helpers';
import { finalize } from 'rxjs/operators';

/**
 * Format of data for the dialog
 */
export interface UpdateCustomIdDialogData {
  campaignId: string;
  entityId: string;
  entityCustomId: EntityCustomIdDetailsFragment;
}

@Component({
  selector: 'app-update-custom-id-dialog',
  templateUrl: './update-custom-id.dialog.html'
})
export class UpdateCustomIdDialog implements OnInit {
  isSaving = false;

  static open(dialog: MatDialog, config: MatDialogConfig<UpdateCustomIdDialogData>) {
    return dialog.open(UpdateCustomIdDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<UpdateCustomIdDialog>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateCustomIdDialogData,
    private _updateEntityCustomIdGQL: UpdateEntityCustomIdGQL,
    private _cd: ChangeDetectorRef,
    private _toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    if (isNilOrEmpty(this.data?.entityId) || isNilOrEmpty(this.data?.campaignId)) {
      throw new Error('An entityId and campaignId must be passed as data to `UpdateCustomIdDialog`');
    }
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }

  saveClicked() {
    if (this.isSaving) {
      return;
    }

    this.isSaving = true;

    const input: UpdateEntityCustomIdInput = {
      campaignId: this.data.campaignId,
      id: this.data.entityCustomId.id,
      value: this.data.entityCustomId.value,
    };

    this._updateEntityCustomIdGQL.mutate({ input })
      .pipe(
        finalize(() => {
          this.isSaving = false;
          this._cd.markForCheck();
        })
      )
      .subscribe((res) => {
        this._toastrService.success('Custom ID updated');
        this.close(res);
      });
  }
}
